import *as _ from 'lodash'
import {EventSpendTypeBO} from "./EventSpendTypeBO";
import {MessageType} from "../PA.Core/PA.Core.IF.Basic";


export class EventSpendTypeBOValidations {

    static ValidateEmptyFields(aBO: EventSpendTypeBO): Promise<void> {

        return new Promise<void>((resolve, error) => {
            if (!aBO.WB_EventSpendType.isActive){
                resolve()
                return
            }


            // Validate Spend Type


            if (_.isEmpty(aBO.WB_EventSpendType.cif.SPENDTYPE_ID) || _.isNull(aBO.WB_EventSpendType.cif.SPENDTYPE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'EmptyId',
                        title: "Spend Type ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_EventSpendType.cif.SPEND_TYPE_NAME)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'EmptyId',
                        title: "Spend Type Name cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyId')
            }

            if (_.isEmpty(aBO.WB_EventSpendType.cif.SOURCE_ID) || _.isNull(aBO.WB_EventSpendType.cif.SOURCE_ID)) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        code: 'EmptyName',
                        type: MessageType.Error,
                        title: "Source ID cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyName')
            }

            if (aBO.WB_EventSpendType.cif.TPM_IND == '1') {

                if (_.isEmpty(aBO.WB_EventSpendType.cif.RATE_LEVEL)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'ratelevel',
                            type: MessageType.Error,
                            title: "Rate Level cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('EmptratelevelyName')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.RATEBASIS_DEFAULT)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'ratebasisdefaults',
                            type: MessageType.Error,
                            title: "Rate Basis Default cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('ratebasisdefaults')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.RATEUOM_DEFAULT)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'rateuomdefaults',
                            type: MessageType.Error,
                            title: "Rate UOM Default cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('rateuomdefaults')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.PAYMENTMETHOD_DEFAULT)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'paymentmethoddefault',
                            type: MessageType.Error,
                            title: "Payment Method Default cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('paymentmethoddefault')
                }

                // if (_.isEmpty(aBO.WB_EventSpendType.cif.FUNDTYPE_DEFAULT)) {
                //     aBO.ValidateMessageProvider.addMessage(
                //         {
                //             code: 'fundtypedefault',
                //             type: MessageType.Error,
                //             title: "Fund Type Default cannot be empty",
                //             description: "",
                //             subtitle: "",
                //             count: 0
                //         })
                // } else {
                //     aBO.ValidateMessageProvider.removeMessage('fundtypedefault')
                // }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.REDEMPTIONRATE_LEVEL)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'redemptionratelevel',
                            type: MessageType.Error,
                            title: "Redemption Rate Level cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('redemptionratelevel')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.WORKFLOW_POLICY)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'workflowpolicy',
                            type: MessageType.Error,
                            title: "Work Flow Policy cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('workflowpolicy')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.INSTOREDATES_POLICY)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'instoredatespolicy',
                            type: MessageType.Error,
                            title: "In Store Dates Policy cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('workinstoredatespolicyflowpolicy')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.SHIPMENTDATES_POLICY)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'shipmentdatespolicy',
                            type: MessageType.Error,
                            title: "Shipment Dates Policy cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('shipmentdatespolicy')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.ORDERDATES_POLICY)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'orderdatespolicy',
                            type: MessageType.Error,
                            title: "Order Dates Policy cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('orderdatespolicy')
                }

                if (_.isEmpty(aBO.WB_EventSpendType.cif.DISTRIBUTIONDATES_POLICY)) {
                    aBO.ValidateMessageProvider.addMessage(
                        {
                            code: 'distributiondatespolicy',
                            type: MessageType.Error,
                            title: "Distribution Dates Policy cannot be empty",
                            description: "",
                            subtitle: "",
                            count: 0
                        })
                } else {
                    aBO.ValidateMessageProvider.removeMessage('distributiondatespolicy')
                }
            }
            if ((_.isEmpty(aBO.WB_EventSpendType.cif.TPM_IND) || aBO.WB_EventSpendType.cif.TPM_IND == "0") && (_.isEmpty(aBO.WB_EventSpendType.cif.PEA_IND) || aBO.WB_EventSpendType.cif.PEA_IND == "0")) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'EmptyUsage',
                        title: "Spend Type's Usage cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyUsage')
            }

            if (!aBO.WB_EventSpendType.cif.WB_MDSET_ID) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'EmptyMasterDataSet',
                        title: "Master Data Set cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptyMasterDataSet')
            }

            if (!aBO.WB_EventSpendType.cif.WB_SALESORG_ID) {
                aBO.ValidateMessageProvider.addMessage(
                    {
                        type: MessageType.Error,
                        code: 'EmptySalesOrg',
                        title: "Sales Org cannot be empty",
                        description: "",
                        subtitle: "",
                        count: 0
                    })
            } else {
                aBO.ValidateMessageProvider.removeMessage('EmptySalesOrg')
            }


            resolve()
        })

    }

}
